import React from "react";
import { Card, useTheme } from "@mui/material";

const CustomCard = ({
  children,
  onClick,
  pSize = 0,
  borderSize = 2,
  shadowSize = 0,
  radius = 16,
  maxHeight,
  mBottom = 0,
  mTop = 0,
  minHeight = "auto",
  disableBorder,
}) => {
  const theme = useTheme();

  return (
    <Card
      onClick={onClick}
      sx={{
        width: "100%",
        padding: `${pSize}px`,
        border: `${disableBorder ? 0 : borderSize}px solid`,
        borderColor: "black.main",
        boxShadow: `0px ${disableBorder ? 0 : shadowSize}px 0px ${
          theme.palette.black.main
        }`,
        borderRadius: `${radius}px`,
        maxHeight: maxHeight ? maxHeight + "px" : "auto",
        minHeight: minHeight ? minHeight + "px" : "auto",
        marginBottom: `${mBottom}px`,
        marginTop: `${mTop}px`,
        cursor: "pointer",
      }}
    >
      {children}
    </Card>
  );
};

export default CustomCard;
